module.exports = __webpack_public_path__ + "assets/img/career.347fe3c1.webp";